import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  TextField,
} from "@mui/material";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";

interface DeleteAccountDialogProps {
  open: boolean;
  onClose: () => void;
  onDelete: () => void;
}

const DeleteAccountDialog: React.FC<DeleteAccountDialogProps> = ({ open, onClose, onDelete }) => {
  const [confirmText, setConfirmText] = useState("");

  const handleClose = () => {
    setConfirmText("");
    onClose();
  };

  const handleDelete = () => {
    onDelete();
    handleClose();
  };

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="xs" fullWidth>
      <DialogTitle sx={{ display: "flex", alignItems: "center", gap: 1, color: "error.main" }}>
        <DeleteForeverIcon color="error" />
        Delete Account?
      </DialogTitle>
      <DialogContent>
        <Typography variant="body2" color="text.secondary" mb={2}>
          This action is <strong>permanent and cannot be undone</strong>. All your data including
          pets, bookings, messages, and payment methods will be permanently deleted.
        </Typography>
        <Typography variant="body2" mb={1}>
          Type <strong>DELETE</strong> to confirm:
        </Typography>
        <TextField
          value={confirmText}
          onChange={(e) => setConfirmText(e.target.value)}
          fullWidth
          size="small"
          placeholder="DELETE"
          autoComplete="off"
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} sx={{ textTransform: "none" }}>
          Cancel
        </Button>
        <Button
          onClick={handleDelete}
          color="error"
          variant="contained"
          disabled={confirmText !== "DELETE"}
          sx={{ textTransform: "none" }}
        >
          Delete My Account
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteAccountDialog;
